import { AxiosStatic, AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';

export default class StatementCodeMappingResource extends FBaseService {
  public async getAll() : Promise<Map<string, string>> {
    const response:AxiosResponse = await this.apiClient.get('/api/rcx/config/core-statement-code-mapping');
    const statementtypes: { [key: string]: string } = response.data.data;
    const statementtypeMap:Map<string, string> = new Map<string, string>();

    Object.keys(statementtypes).forEach((key:string) => {
      statementtypeMap.set(key, statementtypes[key]);
    });

    return statementtypeMap;
  }
}
